import sanitizeHtml from "sanitize-html"

const createMarkup = (data) => ({
  __html: data,
})

const Html = ({ children, ...props }) => {
  const htmlSanitized = sanitizeHtml(children)

  return (
    <div
      className="content"
      {...props}
      dangerouslySetInnerHTML={createMarkup(htmlSanitized)}
    />
  )
}

export default Html
